<ng-container [ngSwitch]="bannerStatus">
  <mable-banner
    *ngSwitchCase="PrefillLmjInfoFromSessionBannerStatus.ERROR"
    data-testid="error-lmj-banner"
    category="headed-banner"
    heading="Pre-fill failed"
    icon="alert-circle"
    [canClose]="false"
  >
    <ng-container class="content">
      <p>Retry or add your information to the form below to post a Last Minute job.</p>

      <mable-button
        expand="block"
        category="purple-500"
        (onClick)="retryPrefill.emit()"
        data-testid="retry-prefill-button"
      >
        Retry pre-fill
      </mable-button>
      <mable-button
        class="half-margin-top"
        expand="block"
        category="outline"
        (onClick)="dismissBanner.emit()"
        data-testid="dismiss-banner-button"
      >
        Dismiss
      </mable-button>
    </ng-container>
  </mable-banner>

  <mable-banner
    *ngSwitchCase="PrefillLmjInfoFromSessionBannerStatus.OUT_OF_RANGE"
    data-testid="out-of-range-lmj-banner"
    category="headed-banner"
    heading="Session must start in the next 4–48 hours"
    icon="alert-circle"
    [canClose]="false"
  >
    <ng-container class="content">
      <p class="ion-no-margin">
        The start time of your planned session is less than 4 hours from now. Select a later start time or, contact us
        if you need support urgently.
      </p>

      <mable-button
        category="link"
        class="ion-no-padding"
        data-testid="contact-us-button"
        (onClick)="openExternalLink('https://mable.com.au/contact-us/')"
      >
        Contact us
      </mable-button>
    </ng-container>
  </mable-banner>

  <mable-banner
    *ngSwitchDefault
    data-testid="prefill-lmj-banner"
    category="headed-banner"
    heading="We've pre-filled this job to save you time"
    icon="information-circle"
    [canClose]="false"
  >
    <ng-container class="content">
      <p>
        We've pre-filled this Last Minute job draft from the session details in your calendar and the original job post.
        Review and then post to local workers.
      </p>
    </ng-container>
  </mable-banner>
</ng-container>
